import Select from '@ben/orion/select';
import type { RestrictionsByType } from '../../../types/columbia';
import type { IModularBenefitContact } from '../../../types/modular-benefit';
import useContactSelectOptions from './use-contact-select-options';
import { useTranslation } from 'react-i18next';

interface ContactSelectProps {
  label: string;
  contacts: IModularBenefitContact[];
  selectedContactIds: string[];
  onChange: (value?: string) => void;
  disabled: boolean;
  restrictionsByType: RestrictionsByType;
}

const ContactSelect = ({
  label,
  contacts,
  selectedContactIds,
  onChange,
  disabled,
  restrictionsByType,
}: ContactSelectProps) => {
  const { t } = useTranslation();

  const { contactSelectOptions, noSelectableContacts } =
    useContactSelectOptions({
      contacts,
      selectedContactIds,
      restrictionsByType,
    });

  const placeholder = noSelectableContacts
    ? t('contacts.noSelectableContacts')
    : t('contacts.assignContact');

  return (
    <Select
      label={label}
      data={contactSelectOptions}
      onChange={onChange}
      disabled={disabled || noSelectableContacts}
      placeholder={placeholder}
    />
  );
};

export default ContactSelect;
